import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button, Image } from 'react-bootstrap'
import imgDownload from '../../../images/Download_Outline.svg'
import Swal from 'sweetalert2'
import { htmlToPdfmake, pdfMake } from '../../../lib/pdf-make'
import NavContract from './contract-nav'
import { useSelector } from 'react-redux'
import Error_false from '../../error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import {
  getContractDetailFileAPI,
  updateEmployAPI
} from '../../../services/contract'
import moment from 'moment'
import 'moment/locale/th'
import { TXTSUCCESS } from '../../../Constants'

export default function ContractFullTimeNav({
  data,
  isCheck3,
  signatureEMP,
  signatureTO,
  signatureCEO,
  signatureVPPD,
  getContractDetail
}) {
  const orgId = useSelector((state) => state.roleReducer.role)
  let [searchParams, setSearchParams] = useSearchParams()
  const contractNo = searchParams.get('contractNo')

  useEffect(() => {
    moment.locale('th')
  }, [isCheck3])

  const getContractDetailFile = async () => {
    const docTypeId = 2
    const body = { orgId, contractNo, docTypeId }
    const result = await getContractDetailFileAPI(body)
    if (!result) return
    if (result.status) {
      window.open(result.result[0]?.url)
    }
  }
  const exportPDF = async (isChecked) => {
    try {
      const file = pdfMake.createPdf({
        images: {
          imgFulltime:
            data.org_id === 1
              ? `${window.location.origin}/image/FullTime/skyFulltime.png`
              : data.org_id === 2
                ? `${window.location.origin}/image/FullTime/MTFullTime.png`
                : data.org_id === 3
                  ? `${window.location.origin}/image/FullTime/astroFulltime.png`
                  : data.org_id === 5
                    ? `${window.location.origin}/image/FullTime/proinsideFullTime.png`
                    : `${window.location.origin}/image/White.png`,
          imgParttime:
            data.org_id === 1
              ? `${window.location.origin}/image/PartTime/skyParttime.png`
              : data.org_id === 2
                ? `${window.location.origin}/image/PartTime/MTParttime.png`
                : data.org_id === 3
                  ? `${window.location.origin}/image/PartTime/ASTROParttime.png`
                  : data.org_id === 5
                    ? `${window.location.origin}/image/PartTime/ProInsideParttime.png`
                    : `${window.location.origin}/image/White.png`,

          imgSquare: `${window.location.origin}/image/square.png`,
          imgCheckBox: `${window.location.origin}/image/checkBox.png`,

          imgSignatureEMP:
            signatureEMP?.url || `${window.location.origin}/image/White.png`,
          imgSignaturePD:
            signatureVPPD?.url || `${window.location.origin}/image/White.png`,
          imgSignatureCEO:
            signatureCEO?.url || `${window.location.origin}/image/White.png`,
          imgSignatureTO:
            signatureTO?.url || `${window.location.origin}/image/White.png`
        },

        info: {
          title: 'สัญญาจ้างงาน'
        },
        // watermark: { text: "ตัวอย่าง", opacity: 0.1 },
        header: function (currentPage, pageCount, pageSize) {
          return {
            columns: [
              {
                image: data.type_id === 1 ? 'imgFulltime' : 'imgParttime',
                width: 350,
                marginTop: 15,
                marginRight: -120
              },
              {
                text: contractNo,
                bold: true,
                opacity: 0.5,
                margin: [0, 20, -141, 0]
              }
            ],
            width: '*',
            height: '100%',
            alignment: 'center'
          }
        },
        content: [
          {
            // marginTop: 10,
            text: [
              {
                text: `สัญญานี้ทำที่ ${data?.org_th || '-'}  เมื่อวันที่ `,
                bold: false,
                marginLeft: 10,

                lineHeight: 1.6,
                preserveLeadingSpaces: true
              },

              //todayDateFromOrbit
              {
                text: `${
                  data.start_date
                    ? moment(data.start_date)
                        .add(543, 'year')
                        .format('DD/MM/YYYY')
                    : '-'
                }`,
                bold: false,
                preserveLeadingSpaces: true,
                decoration: 'underline',
                decorationStyle: 'dotted'
              }
            ],
            alignment: 'left'
            // marginTop: 70
          },
          {
            text: [
              {
                text: `(ก)${signatureCEO?.title_th || '-'}${
                  signatureCEO?.name_th || '-'
                } ${signatureCEO?.surname_th || '-'} อายุ ${
                  signatureCEO?.age
                } ปี/โดยผู้มีอำนาจลงนามท้ายสัญญา/${data.org_th} ${
                  data.address1_th
                } ${data.address2_th} บัตรประจำตัวประชาชนเลขที่ ${
                  signatureCEO?.id_card
                } ซึ่งต่อไปจะเรียกว่า “นายจ้าง” ฝ่ายหนึ่ง `,

                bold: false,
                lineHeight: 1.6,
                preserveLeadingSpaces: true
              }
            ],
            alignment: 'justify',
            marginTop: 5
          },
          {
            text: [
              {
                text: `(ข)${data?.title_th || '-'}${data?.name_th || '-'} ${
                  data?.surname_th || '-'
                } อายุ ${data?.age} ปี อยู่บ้านเลขที่/สำนักงานเลขที่ ${
                  data?.address_current
                } ${
                  data.province_current === 'กรุงเทพมหานคร' ? 'แขวง' : 'ตำบล'
                } ${data?.sub_district_current} ${
                  data.province_current === 'กรุงเทพมหานคร' ? 'เขต' : 'อำเภอ'
                } ${data?.district_current} จังหวัด ${
                  data?.province_current
                } บัตรประจำตัวประชาชนเลขที่ ${
                  data?.id_card ?? ''
                } ซึ่งต่อไปนี้เรียกว่า “ลูกจ้าง” ฝ่ายหนึ่ง`,
                marginRight: 3,
                // alignment: 'left',
                alignment: 'justify',
                preserveLeadingSpaces: true,
                lineHeight: 1.6
              }
            ],
            alignment: 'justify',
            marginTop: 0
          },

          data.type_id === 1
            ? {
                text: [
                  {
                    text: 'โดยที่นายจ้างเป็นผู้ประกอบธุรกิจเกี่ยวกับ ',
                    bold: false,
                    alignment: 'left',
                    preserveLeadingSpaces: true,
                    lineHeight: 1.6
                  },
                  {
                    text: 'การให้บริการด้านเทคโนโลยีสารสนเทศครบวงจร ' + ' ',
                    bold: true,
                    lineHeight: 1.6
                  },
                  {
                    text:
                      'มีความประสงค์จะว่าจ้างลูกจ้าง เข้ามาทำงานในตำแหน่ง ' +
                      ' ',
                    bold: false,
                    lineHeight: 1.6
                  },
                  {
                    text: data?.position_th || '-',
                    bold: true,
                    lineHeight: 1.6
                  },
                  {
                    text: ' และโดยที่ลูกจ้างเป็นผู้มีความรู้ความเชี่ยวชาญ ในตำแหน่งดังกล่าว ประสงค์จะรับจ้างเป็นลูกจ้างให้กับนายจ้างดังนั้น ทั้งสองฝ่ายจึงตกลงทำสัญญากัน โดยมีข้อความดังต่อไปนี้',
                    lineHeight: 1.6,
                    preserveLeadingSpaces: true
                  }
                ],
                marginTop: 10,
                alignment: 'justify'
              }
            : {
                text: [
                  {
                    text: 'โดยที่นายจ้างเป็นผู้ประกอบธุรกิจเกี่ยวกับ ',
                    bold: false,
                    alignment: 'left',
                    preserveLeadingSpaces: true,
                    lineHeight: 1.6
                  },
                  {
                    text: 'การให้บริการด้านเทคโนโลยีสารสนเทศครบวงจร ',
                    bold: true,
                    lineHeight: 1.6,
                    preserveLeadingSpaces: true
                  },
                  {
                    text: 'มีความประสงค์จะว่าจ้างลูกจ้าง เข้ามาทำงานในตำแหน่ง ',
                    bold: false,
                    lineHeight: 1.6,
                    preserveLeadingSpaces: true
                  },
                  {
                    text: data?.position_th || '-',
                    bold: true,
                    lineHeight: 1.6
                  },
                  {
                    text: ' และโดยที่ลูกจ้างเป็นผู้มีความรู้ความเชี่ยวชาญ ในตำแหน่งดังกล่าว ประสงค์จะรับจ้างเป็นลูกจ้างให้กับนายจ้างดังนั้น ทั้งสองฝ่ายจึงตกลงทำสัญญากัน โดยมีข้อความดังต่อไปนี',
                    lineHeight: 1.6,
                    preserveLeadingSpaces: true
                  }
                ],
                alignment: 'justify',
                marginTop: 10
              },

          {
            text: [
              {
                text: 'ข้อ 1. วัตถุประสงค์แห่งสัญญา',
                bold: true,
                alignment: 'center',
                fontSize: 11,
                lineHeight: 1.6
              }
            ],
            marginTop: 15,
            marginBottom: 10
          },

          {
            text: [
              {
                text: `นายจ้างตกลงรับลูกจ้างชื่อ ${data?.title_th || '-'}${
                  data?.name_th || '-'
                } ${data?.surname_th || '-'} ${
                  data.type_id === 1
                    ? 'เป็นลูกจ้างประจำ และ ให้เริ่มทำงานตั้งแต่วันที่ '
                    : 'เป็นลูกจ้างโดยมีกำหนดระยะเวลาการจ้าง และ ให้เริ่มทำงานตั้งแต่ '
                } ${
                  data.type_id === 1
                    ? moment(data?.start_date)
                        .add(543, 'year')
                        .format('D MMMM YYYY')
                    : moment(data?.start_date || '-')
                        .add(543, 'year')
                        .format('D MMMM YYYY') +
                      ' ถึง ' +
                      moment(data?.contract_end || '-')
                        .add(543, 'year')
                        .format('D MMMM YYYY')
                } ทำงานในตำแหน่ง ${data?.position_th ?? ' - '} ระดับ ${
                  data?.level_id ?? ' - '
                } ${data?.division_th} ${data?.faction_th} ${
                  data?.department_th
                } ระยะเวลาทดลองงานตั้งแต่วันที่ ${
                  data.start_date
                    ? moment(data.start_date)
                        .add(543, 'year')
                        .format('DD/MM/YYYY')
                    : '-'
                } ถึง ${
                  data.probation_date
                    ? moment(data.probation_date)
                        .add(543, 'year')
                        .format('DD/MM/YYYY')
                    : '-'
                } มีกำหนดระยะเวลาทดลองงาน 119 วัน ทั้งนี้หากภายในกำหนดระยะเวลาทดลองการทำงาน “นายจ้าง” พิจารณาแล้วเห็นว่า “ลูกจ้าง” มีคุณสมบัติไม่เหมาะสม ไม่ว่าจะเป็นด้านพฤติกรรม ความรู้ความสามารถในการทำงาน หรือมีสถิติการมาทำงานสาย หรือขาดงานบ่อยครั้ง หรือเหตุอื่นใด อันเกี่ยวด้วยสภาพการทำงาน ตามที่ระบุไว้ ในกฎระเบียบข้อบังคับ เกี่ยวกับการทำงานของบริษัทแล้ว “นายจ้าง” อาจใช้สิทธิเลิกจ้าง โดยแจ้งล่วงหน้าตามกฎหมาย ก่อนครบกำหนดระยะเวลาทดลองงาน หรือ จ่ายสินจ้างแทนการบอกกล่าวล่วงหน้าแทนก็ได้`,
                bold: false,
                lineHeight: 1.6,
                preserveLeadingSpaces: true
              }
            ],
            alignment: 'justify'
          },
          {
            text: [
              {
                text: 'ข้อ 2. ค่าจ้างและการชำระ',
                bold: true,
                alignment: 'center',
                fontSize: 11,
                lineHeight: 1.6
              }
            ],
            marginTop: 15,
            marginBottom: 8
            // pageBreak: "before",
          },
          {
            text: [
              {
                text: '\tทั้งสองฝ่ายตกลงกำหนดค่าจ้างในอัตราค่าจ้างที่ระบุไว้ในใบแจ้งค่าตอบแทน เพื่อให้ขั้นตอนการจ่ายค่าจ้างให้แก่ลูกจ้างเป็นไปอย่าง สอดคล้องในทางปฏิบัติงานของลูกจ้าง นายจ้างมีหลักเกณฑ์การตัดรอบเพื่อเก็บสถิติการทำงานและนำข้อมูลไปใช้คำนวณการจ่าย เงินเดือน โดยมีรายละเอียด ดังต่อไปนี้',

                preserveLeadingSpaces: true,
                lineHeight: 1.6,
                marginBottom: 10
              }
            ],
            alignment: 'justify'
          },

          {
            alignment: 'justify',
            text: [
              {
                text: '\t(1) ',
                bold: false,
                preserveLeadingSpaces: true,
                lineHeight: 1.6
                // pageBreak: 'before'
              },
              {
                text: 'จ่ายเงินเดือนทุกวันสิ้นเดือนหากตรงกับวันหยุดเสาร์ และอาทิตย์ บริษัทจะเลื่อนการจ่ายก่อนการหยุด',
                lineHeight: 1.6,
                marginBottom: 10,
                alignment: 'justify'
              }
            ]
          },
          {
            alignment: 'justify',
            text: [
              {
                text: '\t(2) ',
                bold: false,
                alignment: 'left',
                preserveLeadingSpaces: true
              },
              {
                text: 'ตัดรอบสรุปตารางการมาทำงานของพนักงาน ได้แก่ การลากิจ การขาดงาน และการมาสาย ระหว่างวันที่ 16 – 15 ของเดือน แล้วนำส่งส่วนงานเงินเดือนภายในวันที่ 24 ของทุกเดือนเพื่อเป็นข้อมูลในการคำนวณการจ่ายเงินเดือน ',
                lineHeight: 1.6,
                alignment: 'justify'
              }
            ]
          },
          {
            alignment: 'justify',
            text: [
              {
                text: '\tยกตัวอย่าง ',
                bold: true,
                // alignment: 'justify',
                preserveLeadingSpaces: true,
                lineHeight: 1.6
              },
              {
                text: 'สรุปการทำงานของพนักงานวันที่ 16 กรกฎาคม ถึงวันที่ 15 สิงหาคม เป็นการสรุปเพื่อใช้คำนวณการจ่ายเงินเดือน ของเดือนสิงหาคม',
                lineHeight: 1.6,
                alignment: 'justify'
              }
            ]
          },
          {
            text: [
              {
                text: '\t(3) ',
                bold: false,
                alignment: 'justify',
                preserveLeadingSpaces: true
              },
              {
                text: 'ทั้งนี้ วิธีและขั้นตอนการปฏิบัติ ให้ทั้งสองฝ่ายยึดถือ และปฏิบัติตามข้อบังคับเกี่ยวกับการทำงาน (พนักงานประจำสำนักงาน) หมวดที่ 6 การบริหารค่าจ้าง/เงินเดือน ',
                lineHeight: 1.6
              }
            ]
            // pageBreak: 'before',
            // marginTop: 75
          },
          {
            text: [
              {
                text: '\t\tโดยนายจ้างจะจ่ายค่าจ้าง ให้แก่ลูกจ้างในวันสุดท้ายของทุกเดือน ณ ที่ทำการของนายจ้าง หรือจ่ายผ่านบัญชีเงินฝาก ธนาคารของลูกจ้าง หรือตามที่นายจ้างเห็นสมควร',
                bold: false,
                alignment: 'justify',
                preserveLeadingSpaces: true,
                lineHeight: 1.6
              }
            ]
          },
          {
            text: [
              {
                text: 'ข้อ 3. ข้อสัญญาของลูกจ้าง',
                bold: true,
                alignment: 'center',
                fontSize: 11
              }
            ],
            marginTop: 23,
            marginBottom: 10
          },
          {
            text: 'ลูกจ้างสัญญาและทราบดีว่า',
            lineHeight: 1.6
          },
          {
            text: '(3.1) จะปฏิบัติตามคำรับรองของลูกจ้าง คำรับรองที่ปรากฏอยู่ในใบสมัครงาน (ถ้ามี) ข้อบังคับเกี่ยวกับการทำงาน ระเบียบ ประกาศ และหรือคำสั่งของนายจ้างที่มีอยู่ในขณะทำสัญญา หรือที่จะมีขึ้นต่อไปในภายหน้า และตกลงให้ถือว่า คำรับรอง ข้อบังคับเกี่ยวกับ การทำงาน ระเบียบ ประกาศ และหรือคำสั่งดังกล่าวเป็นส่วนหนึ่งของสัญญานี้ด้วย',
            lineHeight: 1.6,

            alignment: 'justify',
            preserveLeadingSpaces: true
          },
          {
            text: '\t\tลูกจ้างสัญญาว่าหากลูกจ้าง กระทำการหรืองดเว้นการกระทำการหรือยินยอมให้บุคคลอื่นใดกระทำการใด ๆ โดยเจตนาหรือ กระทำการประมาทเลินเล่อ เป็นเหตุให้นายจ้างได้รับ ความเสียหายอย่างร้ายแรง ไม่ว่าโดยตรงหรือโดยโดยอ้อม ลูกจ้างตกลงยินยอม ชดใช้ค่าเสียหายให้กับนายจ้างโดยครบถ้วนเต็มจำนวน',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.2) นายจ้างมีสิทธิ ดังต่อไปนี้',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t\t(3.2.1) กำหนด แก้ไขเปลี่ยนแปลง ยกเลิก หรือเพิ่มเติมวันและเวลาทำงานปกติ วันหยุด วันลา เวลาพักและหรือสวัสดิการ',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t\t(3.2.2) กำหนด หรือแก้ไขเปลี่ยนแปลงข้อบังคับเกี่ยวกับการทำงาน สภาพการจ้าง รวมทั้งการโอนย้ายตำแหน่ง หรือหน้าที่การ งานในบริษัท หรือบริษัทในเครือตามที่นายจ้างจะเห็นสมควร โดยลูกจ้างพร้อมที่จะปฏิบัติงานทั้งในเขตกรุงเทพมหานคร และต่าง จังหวัด',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            // width: 50,
            text: '(3.3) การที่นายจ้างตกลงรับลูกจ้างเข้าทำงานกับบริษัทตามสัญญานี้ เนื่องมาจากลูกจ้างได้แจ้ง แสดงหลักฐาน หรือให้คำรับรองต่อ นายจ้างว่า เป็นผู้มีคุณสมบัติ ประวัติและความประพฤติ และมีความสามารถตามที่นายจ้างกำหนดไว้ ซึ่งลูกจ้างได้ทราบรายละเอียด ต่าง ๆ ดีแล้ว ทั้งนี้ เอกสารประกอบการสมัครงานให้ถือเป็นส่วนหนึ่งของสัญญาจ้างงานฉบับนี้ด้วย ดังนั้น หากปรากฏในภายหลังไม่ว่า กรณีใด ๆ ว่าลูกจ้างมีคุณสมบัติ หรือความสามารถไม่ตรง หรือ ไม่เหมาะสมกับที่ได้แจ้งแสดงหลักฐาน หรือรับรองไว้ หรือแสดงหลัก ฐาน อันเป็นเท็จ หรือปกปิดข้อความจริงซึ่งควรบอกให้แจ้งอันอาจทำให้นายจ้างไม่รับเข้าทำงานกับนายจ้าง ถือเป็นการผิดสัญญา และ จงใจทำให้นายจ้างได้รับความเสียหาย ลูกจ้างยินยอมให้นายจ้างมีสิทธิเลิกจ้างลูกจ้างได้ทันทีโดยไม่ต้องจ่ายค่าชดเชยและ ค่าเสียหาย ใด ๆ ทั้งสิ้น',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.4) หากเกิดความชำรุดเสียหาย สูญหายแก่ทรัพย์สินของนายจ้างซึ่งอยู่ภายในที่ทำการของนายจ้างที่ลูกจ้างทำงานอยู่ และอยู่ใน ความดูแลรับผิดชอบของลูกจ้าง ไม่ว่าจะเกิดจากความผิดของลูกจ้างหรือไม่ก็ตาม ลูกจ้างตกลงเป็นผู้รับผิดชอบแก้ไข จัดหามาแทน หรือชดใช้ค่าเสียหายแก่นายจ้างแล้วแต่กรณีเองทั้งสิ้นทันทีที่นายจ้างแจ้งให้ลูกจ้างรับผิดชอบ',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.5) จะไม่แสวงหา หรือรับเอาไม่ว่าในทางตรง หรือทางอ้อมเพื่อตนเองหรือเพื่อผู้อื่นซึ่งทรัพย์สินหรือประโยชน์ใด ๆ ในการที่ลูกจ้าง กระทำ หรือละเว้นการกระทำตามตำแหน่งหน้าที่ หรือกระทำการที่ได้รับมอบหมาย นอกจากนายจ้างจ่ายให้ หรือพึงจ่ายให้ตามปกติ ตามระเบียบ หรือตามข้อบังคับเกี่ยวกับการทำงานของนายจ้าง',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
            // pageBreak: 'before',
            // marginTop: 70
          },
          {
            text: '(3.6) จะไม่ประกอบธุรกิจ หรือทำงานให้กับบริษัทที่ประกอบธุรกิจประเภทเดียวกันกับนายจ้าง รวมทั้งจะไม่กระทำการใด ๆ อันเป็น การแข่งขันกับธุรกิจของนายจ้าง เฉพาะที่อาศัยข้อมูลการค้าอันเป็นความลับทางการค้าของนายจ้าง ไม่ว่าทางตรงหรือทางอ้อม ตลอด จนไม่กระทำหรือช่วยเหลือ หรือยินยอมให้บุคคลใดกระทำการ ดังกล่าว ตลอดระยะเวลาของสัญญานี้ และภายในกำหนด ระยะเวลา 6 เดือน นับแต่วันที่สัญญานี้สิ้นสุดลง',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.7) ลูกจ้างจะไม่กระทำการใช้ เปิดเผย และหรือเอาไป ซึ่งข้อมูลการค้าอันเป็นความลับทางการค้าของนายจ้าง และหรืออนุญาตให้ บุคคลอื่นกระทำการดังกล่าว โดยไม่ได้รับความยินยอมจากนายจ้างเป็นลายลักษณ์อักษร ไม่ว่าข้อมูลการค้านั้นจะอยู่ในรูปแบบใด',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.8) ลูกจ้างตกลงให้บรรดาลิขสิทธิ์ และหรือสิทธิบัตร และหรือทรัพย์สินทางปัญญาอื่นใดที่เกิดขึ้นในระหว่างที่เป็นลูกจ้างของ นายจ้างเฉพาะที่เกี่ยวข้องกับงานในตำแหน่งหน้าที่ ให้ตกเป็นของนายจ้างแต่เพียงผู้เดียว นับแต่เวลาที่ได้กระทำขึ้น และจะไม่ ทำซ้ำ ดัดแปลง หรือกระทำการใด ๆ อันเป็นการละเมิดต่อนายจ้าง ตลอดจนไม่ยินยอมให้บุคคลใดกระทำการดังกล่าว ไม่ว่าจะเกิดความเสีย หายแก่นายจ้างหรือไม่ก็ตาม รวมทั้งจะไม่นำงานที่ละเมิดทรัพย์สินทางปัญญาของบุคคลอื่นเข้ามาทำงาน ตามสัญญานี้ด้วย',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.9) ลูกจ้างต้องรักษาความลับ และหรือข้อมูลภายในของบริษัทฯ ไม่นำไปเปิดเผย หรือแสวงหาผลประโยชน์แก่ตนเอง หรือเพื่อ ผลประโยชน์แก่ผู้อื่น ไม่ว่าทางตรงหรือทางอ้อม รวมทั้งต้องไม่ทำการซื้อขาย โอนหรือรับโอนหลักทรัพย์ของบริษัทฯ โดยใช้ความลับ และหรือข้อมูลภายในของบริษัท และหรือเข้าทำนิติกรรมอันใด โดยใช้ความลับ และหรือข้อมูลภายในของบริษัท อันอาจก่อให้เกิด ความเสียหายต่อบริษัท ไม่ว่าทางตรงหรือทางอ้อม',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.10)  ลูกจ้างในหน่วยงานที่ได้รับข้อมูลภายในบริษัท ต้องไม่ใช้ข้อมูลดังกล่าวก่อนเปิดเผยสู่สาธารณชน และต้องไม่ทำการ ซื้อขาย โอนหรือรับโอนหลักทรัพย์ของบริษัทฯ ในช่วงระยะเวลา 1 เดือน ก่อนที่งบการเงินรายไตรมาสและงบการเงินประจำปี จะเปิดเผยสู่ สาธารณชน และหลังการเปิดเผยข้อมูลดังกล่าวอย่างน้อย 3 วัน',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.11) หากลูกจ้างมีหนี้ที่เป็นไปเพื่อสวัสดิการที่เป็นประโยชน์แก่ลูกจ้างฝ่ายเดียว ลูกจ้างตกลงยินยอมให้นายจ้างมีสิทธิหักหนี้จำนวน ดังกล่าวจากค่าจ้าง ค่าล่วงเวลา ค่าทำงานในวันหยุด และค่าล่วงเวลาในวันหยุดได้ ไม่ว่าทั้งหมดหรือบางส่วน ไม่ว่าสัญญานี้จะสิ้นสุดลง แล้วหรือไม่ก็ตาม จนกว่าหนี้ดังกล่าวจะระงับสิ้นไป',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t\tลูกจ้างสัญญาว่าจะปฏิบัติตามกฎหมายว่าด้วยภาษีอากร แรงงาน และกฎหมายอื่น ๆ ที่เกี่ยวข้องโดยเคร่งครัดทั้งยินยอมให้ นายจ้าง หักภาษีเงินได้ ณ ที่จ่าย หรือหักเงินสมทบเข้ากองทุนประกันสังคม เพื่อส่งให้แก่ทางราชการตามกฎหมาย',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.12) การลาออกจากการเป็นพนักงานของลูกจ้างต้องแจ้งให้นายจ้างอนุมัติรับทราบเป็นลายลักษณ์อักษรล่วงหน้าเป็นเวลาอย่างน้อย',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            stack: [
              {
                columns: [
                  {
                    image: 'imgCheckBox',
                    width: 10
                  },
                  {
                    text: ' 30 วัน',
                    alignment: 'left',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },

                  {
                    image: 'imgSquare',
                    width: 10
                  },
                  {
                    text: ' 60 วัน',
                    alignment: 'left',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },
                  {
                    image: 'imgSquare',
                    width: 10
                  },

                  {
                    text: ' 90 วัน',
                    alignment: 'left',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },
                  {
                    image: 'imgSquare',
                    width: 10
                  },
                  {
                    text: ' อื่น ๆ',
                    alignment: 'left',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  }
                ]
              }
            ],
            marginTop: 5,
            marginBottom: 10
          },
          {
            text: '\t\tซึ่งนายจ้างตกลงกับลูกจ้างเพื่อมิให้มีผลกระทบเกิดความเสียหายแก่นายจ้าง นับจากวันที่นายจ้างอนุมัติรับทราบเป็นลายลักษณ์ อักษร จึงจะถือว่าการลาออกของลูกจ้างนั้นถูกต้องสมบูรณ์ตามสัญญาจ้างงานฉบับนี้ ',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t\t3.12 (ก) ก่อนสถานภาพการเป็นลูกจ้างสิ้นสุดลง ลูกจ้างต้องทำการส่งมอบงานซึ่งเป็นงานต่อเนื่อง หรืองานอยู่ระหว่างทำ ต่อให้ผู้รับทำหน้าที่ต่อจากลูกจ้าง หรือตัวแทน รับมอบงานเป็นลายลักษณ์อักษรจึงจะถือว่าการลาออกนั้นเสร็จสิ้นสมบูรณ์',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
            // pageBreak: 'before',
            // marginTop: 70
          },
          {
            text: '\t\t3.12 (ข) หากลูกจ้างมิได้ปฏิบัติตามข้อ 3.12 (ก) ลูกจ้างตกลงยินยอมให้นายจ้างมีสิทธิชะลอการจ่ายค่าจ้าง ค่าล่วงเวลา ค่าทำงานในวันหยุด และค่าล่วงเวลาในวันหยุดได้ ไม่ว่าทั้งหมดหรือบางส่วน ไม่ว่าสัญญานี้จะสิ้นสุดลงแล้วหรือไม่ก็ตามจนกว่า ลูกจ้างจะทำการส่งมอบงานตามข้อ 3.12 (ก) ให้เสร็จสิ้นเป็นที่เรียบร้อยแก่นายจ้าง',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.13) ภายหลังจากที่ลูกจ้างได้ลาออก และพ้นสภาพจากการเป็นพนักงานแล้ว หากนายจ้างพบว่าเกิดความเสียหายอันเนื่องมาจาก การปฏิบัติหน้าที่ของลูกจ้างในขณะที่ยังเป็นพนักงานอยู่ ลูกจ้างรับว่าจะชดใช้ความเสียหายที่เกิดแก่นายจ้างตามความเสียหายที่เกิด ขึ้นจริงทั้งจำนวนทันที ที่นายจ้างแจ้งให้รับทราบเป็นลายลักษณ์อักษรพร้อมหลักฐานซึ่งแสดงถึงที่มาของความเสียหายที่เกิดแก่ นายจ้าง  ',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '(3.14) ลูกจ้างรับว่า จะไม่เรียกร้องค่าชดเชยกับนายจ้าง ซึ่งเลิกจ้างในกรณีหนึ่ง กรณีใด ดังต่อไปนี้',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t(ก) ทุจริตต่อหน้าที่หรือกระทำความผิดอาญาโดยเจตนาแก่นายจ้าง',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t(ข) จงใจให้นายจ้างได้รับความเสียหาย',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t(ค) ประมาทเลินเล่อเป็นเหตุให้นายจ้างได้รับความเสียหายอย่างร้ายแรง',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t(ง) ฝ่าฝืนข้อบังคับเกี่ยวกับการทำงานหรือระเบียบหรือคำสั่งของนายจ้างอันชอบด้วยกฎหมายและเป็นธรรม และนายจ้างได้ ตักเตือนเป็นหนังสือแล้ว เว้นแต่กรณีที่ร้ายแรงนายจ้างไม่จำเป็นต้องตักเตือน หนังสือเตือน ให้มีผลบังคับได้ไม่เกินหนึ่งปีนับแต่วันที่ ลูกจ้างได้กระทำผิด',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t(จ) ละทิ้งหน้าที่เป็นเวลาสามวันทำงานติดต่อกันไม่ว่าจะมีวันหยุดคั่นหรือไม่ก็ตามโดยไม่มีเหตุอันสมควร',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: '\t(ฉ) ได้รับโทษจำคุกตามคำพิพากษาถึงที่สุดให้จำคุก เว้นแต่เป็นโทษสำหรับความผิดที่ได้กระทำโดยประมาท หรือความผิดลหุโทษ',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: [
              {
                text: 'ข้อ 4. หลักประกันการปฏิบัติตามสัญญา',
                bold: true,
                alignment: 'center',
                fontSize: 11,
                lineHeight: 1.6
              }
            ],
            marginTop: 15,
            marginBottom: 10
          },

          {
            text: '\tเพื่อเป็นหลักประกันการปฏิบัติตามสัญญาตลอดจนความรับผิดและหนี้สินอื่นใดของลูกจ้าง ลูกจ้างตกลงว่า จะจัดให้ข้าราชการ ระดับ ซี 4 ขึ้นไป หรือบุคคล ซึ่งเป็นลูกจ้างเอกชนมีอัตราเงินเดือนเป็น 2 เท่าของลูกจ้าง เข้าค้ำประกันการปฏิบัติตามสัญญาของ ลูกจ้างให้กับนายจ้าง เป็นกรณีไปตามแต่ที่นายจ้างกำหนดในแต่ละตำแหน่งงานที่ต้องรับผิดชอบเกี่ยวกับการเงินหรือทรัพย์สินของ นายจ้างซึ่งอาจก่อให้เกิดความเสียหายแก่นายจ้างได้หากสัญญานี้ยังไม่สิ้นสุดลง แต่ผู้ค้ำประกันหลุดพ้นความรับผิดจากสัญญานี้ไป ไม่ว่าด้วยเหตุใด ลูกจ้างจะต้องจัดหาผู้ค้ำประกันใหม่ ซึ่งมีคุณสมบัติตรงตามหลักเกณฑ์ และเงื่อนไข ตามวรรคแรกให้กับนายจ้าง ก่อนการเริ่มงาน ตามที่ระบุไว้ในสัญญาจ้างงานฉบับนี้',

            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          //edit to icon

          {
            stack: [
              {
                columns: [
                  {
                    image: 'imgSquare',
                    width: 10
                  },
                  {
                    text: '  ต้องทำสัญญาค้ำประกัน',
                    alignment: 'left',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },
                  {
                    image: 'imgCheckBox',
                    width: 10
                  },
                  {
                    text: ' ไม่ต้องทำสัญญาค้ำประกัน',
                    alignment: 'left',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  },
                  {
                    image: 'imgSquare',
                    width: 10
                  },
                  {
                    text: '  อื่น ๆ',
                    alignment: 'left',
                    marginTop: -2,
                    preserveLeadingSpaces: true
                  }
                ]
              }
            ],
            marginBottom: 15,
            marginTop: 15
          },
          {
            text: [
              {
                text: 'ข้อ 5. การผิดนัดผิดสัญญา',
                bold: true,
                alignment: 'center',
                fontSize: 11,
                lineHeight: 1.6
              }
            ],
            // marginTop: 15,
            marginBottom: 10
            // pageBreak: 'before',
            // marginTop: 70
          },
          {
            text: ' หากลูกจ้างผิดนัดผิดสัญญานี้โดยจงใจหรือประมาทเลินเล่ออย่างร้ายแรง ทำให้นายจ้างได้รับความเสียหายลูกจ้างตกลงยินยอมให้ นายจ้างมีสิทธิบอกเลิกสัญญา และหรือ มีสิทธิเรียกค่าเสียหายจากลูกจ้าง โดยให้นายจ้างมีสิทธิ นำค่าเสียหายมาหักออกจากค่าจ้าง ค่าล่วงเวลา ค่าทำงานในวันหยุด และหรือค่าล่วงเวลาในวันหยุดได้ และหากยังไม่เพียงพอกับค่าเสียหายที่เกิดขึ้น นายจ้างมีสิทธิเรียก ค่าเสียหายจากลูกจ้างได้อีก',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6
          },
          {
            text: [
              {
                text: 'ข้อ 6. ข้อตกลงอื่น ๆ',
                bold: true,
                alignment: 'center',
                fontSize: 11,
                lineHeight: 1.6
              }
            ],
            marginTop: 15,
            marginBottom: 10
          },
          {
            text: '6.1 การผ่อนผัน ผ่อนเวลา หรือการละเว้นการใช้สิทธิใด ๆ ของคู่สัญญาฝ่าย หนึ่งที่มีอยู่ต่อคู่สัญญาอีกฝ่ายหนึ่งตามสัญญานี้ ไม่ถือว่า คู่สัญญาฝ่ายนั้นได้สละสิทธิประโยชน์นั้นต่อคู่สัญญาอีกฝ่ายหนึ่งแต่อย่างใด',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            marginBottom: 5,
            lineHeight: 1.6
          },
          {
            text: '6.2 การบอกกล่าว ทวงถาม หรือส่งเอกสารใด ๆ อันพึงมีไปยังคู่สัญญาอีก ฝ่ายหนึ่งตามภูมิลำเนาตามสัญญาให้ถือว่าเป็นการส่งโดย ชอบ และคู่สัญญาอีกฝ่ายได้รับทราบแล้ว นับแต่วันที่คำบอกกล่าว ทวงถาม หรือเอกสารนั้นพึงไปถึงตามปกติ',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            marginBottom: 10,
            lineHeight: 1.6
          },
          {
            text: '\t\t\t\tสัญญานี้ทำขึ้นเป็นสองฉบับ มีข้อความถูกต้องตรงกัน ทั้งสองฝ่ายได้ทราบ และเข้าใจ ข้อความในสัญญานี้โดยตลอดดีแล้ว เห็นว่าถูกต้องตรงตามเจตนาของตน จึงลงลายมือชื่อ และประทับตราบริษัท (ถ้ามี) ไว้เป็นสำคัญต่อหน้าพยาน และต่างยึดถือไว้ฝ่ายละ ฉบับ',
            alignment: 'justify',
            preserveLeadingSpaces: true,
            lineHeight: 1.6,
            marginBottom: 20
          },
          {
            columns: [
              {
                stack: [
                  {
                    image: 'imgSignatureCEO',
                    width: 120,
                    alignment: 'center',
                    marginTop: 15,
                    marginBottom: -15
                    // marginLeft: 35,
                    // lineHeight: 1.6,
                  },
                  {
                    text: [
                      {
                        text: 'ลงชื่อ...........................................................นายจ้าง',
                        bold: false,
                        alignment: 'center',
                        preserveLeadingSpaces: true
                      }
                    ],
                    marginTop: 5
                  },
                  {
                    text: [
                      {
                        text: `( ${
                          signatureCEO?.title_th || '               '
                        }${signatureCEO?.name_th || '               '} ${
                          signatureCEO?.surname_th || '               '
                        } )`,
                        bold: false,
                        alignment: 'center'

                        // preserveLeadingSpaces: true,
                      }
                    ],
                    marginBottom: 10,
                    marginTop: 15
                    // marginLeft: 38,
                  }
                ]
              },

              {
                stack: [
                  {
                    image: 'imgSignatureEMP',
                    width: 150,
                    alignment: 'center',
                    marginTop: 15,
                    marginBottom: -15
                    // marginLeft: 40,
                  },
                  {
                    text: 'ลงชื่อ .....................................................ลูกจ้าง',
                    alignment: 'center',
                    marginTop: 0
                    // marginRight: 20,
                  },

                  {
                    text: `( ${signatureEMP?.title_th || '               '} ${
                      signatureEMP?.name_th || '               '
                    } ${signatureEMP?.surname_th || '               '} )`,

                    bold: false,
                    alignment: 'center',

                    preserveLeadingSpaces: true,

                    // marginRight: 50,
                    marginTop: 15
                  }
                ]
              }
            ]
          },
          {
            columns: [
              {
                stack: [
                  {
                    image: 'imgSignaturePD',
                    width: 120,
                    alignment: 'center',
                    marginTop: 15,
                    marginBottom: -15
                    // marginLeft: 35,
                    // lineHeight: 1.6,
                  },
                  {
                    text: [
                      {
                        text: 'ลงชื่อ...........................................................พยาน',
                        bold: false,
                        alignment: 'center',
                        preserveLeadingSpaces: true
                      }
                    ],
                    marginTop: 5
                  },
                  {
                    text: [
                      {
                        text: `( ${
                          signatureVPPD?.title_th || '               '
                        } ${signatureVPPD?.name_th || '               '} ${
                          signatureVPPD?.surname_th || '               '
                        } )`,
                        bold: false,
                        alignment: 'center'

                        // preserveLeadingSpaces: true,
                      }
                    ],
                    marginBottom: 10,
                    marginTop: 15
                    // marginLeft: 38,
                  }
                ]
              },

              {
                stack: [
                  {
                    image: 'imgSignatureTO',
                    width: 150,
                    alignment: 'center',
                    marginTop: 15,
                    marginBottom: -15
                  },
                  {
                    text: 'ลงชื่อ .....................................................พยาน',
                    alignment: 'center',
                    marginTop: -5
                  },

                  {
                    text: `( ${signatureTO?.title_th || '               '} ${
                      signatureTO?.name_th || '               '
                    } ${signatureTO?.surname_th || '               '} )`,

                    bold: false,
                    alignment: 'center',
                    preserveLeadingSpaces: true,
                    marginTop: 15
                  }
                ]
              }
            ]
          }
        ],

        footer: function (cp, pc, ps) {
          //add logic
          return {
            stack: [
              {
                canvas: [
                  {
                    type: 'line',
                    x1: 0,
                    y1: 0,
                    x2: 500,
                    y2: 0,
                    margin: [20, 10, 20, 0], //ซ้าย บน ขวา ล่าง
                    lineWidth: 0.2,
                    lineColor: 'black'
                  }
                ],
                // marginTop: -20,
                marginBottom: 10,
                alignment: 'center'
              },

              {
                text: `${data.org_th} ${data.address1_th} ${data.address2_th} โทรศัพท์: ${data.tel_no} โทรสาร: ${data.fax_no}`,

                color: '#464EA4',
                fontSize: 6,
                alignment: 'left',
                margin: [30, 0, 30, 0], //ซ้าย บน ขวา ล่าง
                lineHeight: 1.2
              },
              {
                text: `${data.org_en} ${data.address1_en} ${data.address2_en} Telephone: ${data.tel_no} Fax: ${data.fax_no}`,
                color: '#464EA4',
                fontSize: 6,
                alignment: 'left',
                margin: [30, 0, 30, 0], //ซ้าย บน ขวา ล่าง
                lineHeight: 1.2
              },
              {
                text: ` ${cp} of ${pc}`,
                alignment: 'center',
                bold: true,
                margin: [0, 10, 0, 10],
                marginBottom: 0,
                fontSize: 8
              }
            ],
            widths: ['*', 100]
          }
        },

        pageSize: 'A4',
        defaultStyle: {
          fontSize: 10,
          bold: false,
          color: '#2A2A2A',
          font: 'THSarabunNew',
          alignment: 'justify'
        },
        pageMargins: [40, 120, 40, 58] //ซ้าย บน ขวา ล่าง
      })

      if (isChecked === 1) {
        file.getBlob((blob) => {
          onSubmitEdit(blob)
        })
      } else {
        file.open()
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Fail!',
        text: error,
        customClass: {
          confirmButton: 'btn btn-success'
        }
      })
    }
  }

  const onSubmitEdit = (file) => {
    var formData = new FormData()
    formData.append('orgId', orgId)
    formData.append('file', file)
    formData.append('contractNo', contractNo)
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to confirm?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        updateContractConfirm(formData)
      }
    })
  }

  const updateContractConfirm = async (param) => {
    const datas = await updateEmployAPI(param)
    if (!datas) return
    if (datas.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getContractDetail()
      })
    } else {
      Error_false(datas)
    }
  }

  return (
    <>
      <div
        className="p-3 d-flex d-flex justify-content-between bg-white"
        style={{ position: 'sticky', top: '0px' }}
      >
        <span className=" d-flex gap-3  rounded-top pointer-event">
          <NavContract />
        </span>

        <div className="gap-3 d-flex ">
          {isCheck3 === 1 ? (
            <>
              <Button
                size="sm"
                style={{ maxHeight: '33px' }}
                onClick={() => getContractDetailFile()}
              >
                <Image
                  style={{
                    width: '10px',
                    marginRight: 5
                  }}
                  className="mb-1 "
                  src={imgDownload}
                />
                Download PDF
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="outline-secondary"
                style={{ maxHeight: '33px' }}
                size="sm"
                onClick={() => {
                  exportPDF(1)
                }}
              >
                Confirm
              </Button>

              <Button
                onClick={() => {
                  exportPDF(2)
                }}
                size="sm"
                style={{ maxHeight: '33px' }}
              >
                <Image
                  style={{
                    width: '10px',
                    marginRight: 5
                  }}
                  className="mb-1 "
                  src={imgDownload}
                />
                Download PDF
              </Button>
            </>
          )}
        </div>
      </div>
    </>
  )
}
